import { type HttpGet, mapServerError } from '@/shared/infra/http'
import type { ParticipantComplianceResult } from '@/shared/domain'
import type { LoadParticipantCompliance } from '@/shared/domain'

export class EdgeLoadParticipantComplianceRepository {
  constructor(private readonly http: HttpGet) {}

  execute: LoadParticipantCompliance = async ({ orgId, orgType, bookingId, scheduleId }) => {
    const search = new URLSearchParams({ orgId, orgType })
    if (bookingId) search.set('bookingId', bookingId)
    if (scheduleId) search.set('scheduleId', scheduleId)
    try {
      return await this.http.get<ParticipantComplianceResult>({
        url: `/licenses/compliance/participants?${search.toString()}`,
      })
    } catch (err) {
      mapServerError(err, {})
    }
  }
}
